export const URL = 'https://www.omdbapi.com/?i=tt3896198&apikey=686f19c3';
export const KEY = '686f19c3';
export const ORIGIN_LINK = 'https://omdbapi.com/';
export const DEFAULT_SEARCH_REQUEST = 'Lord';
export const DEFAULT_PAGE = 1;
export const DEFAULT_PLACEHOLDER_IMAGE = '../../assets/error-404.svg';
export const KEY_YANDEX = 'trnsl.1.1.20200507T154953Z.447eb504d61f94c1.ed3070db979821486f8a3abe638847104f98eafd';
export const URL_YANDEX = 'https://translate.yandex.net/api/v1.5/tr.json/translate?';
export const TRANSLATE_LANGUAGE_YANDEX = 'ru-en';
